import React, { useEffect, useState } from "react";

// material ui
import { DashboardTwoTone } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import { get_cookies } from "../../components/Cookies/Cookies";
import Preloader from "../../components/Preloader/Preloader";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  textField: {
    marginTop: "-15px",
  },
  //   whiteContainer: {
  //     //     background: "rgba(255, 255, 255, 0.9)",

  //     // marginBottom: '1.5em',
  //     borderRadius: "0.75em",
  //     display: "flex",
  //     justifyContent: "space-between",
  //   },
  cardLeft: {
    width: "45%",
  },
  cardRight: {
    width: "45%",
  },
  cardHeader: {
    borderRadius: "2px",
    padding: "10px",
    boxShadow: "0 0 1px rgba(166, 166, 185, 0.5)",
    marginTop: "20px",
    background: "rgba(255, 255, 255, 0.9)",
  },
    cardHeaderBody: {
    display: "flex",
    alignItems: "left",
    justifyContent: "space-between",
  },
  card: {
//     border: "1px solid #ddd",
    marginRight:'25px',
    borderRadius: "2px",
    padding: "20px",
    width: "300px",
    textAlign: "left",
    boxShadow: "0 0 1px rgba(166, 166, 185, 0.5)",
    marginTop: "20px",
    background: "rgba(255, 255, 255, 0.9)",
  },
  cardDiv: {
    display: "flex",
    alignItems: "left",
    // justifyContent: "space-between",
  },
  whiteContainer: {
    // background: 'rgba(255, 255, 255, 0.9)',
    //     border: "1px solid black",
  },
}));

const Dashboard = () => {
  const classes = useStyles();
  const [activationcardsList, setActivationCardsList] = useState("");
  const [releaseList, setReleaseList] = useState("");
  const [accountUpgradeCount, setAccountUpgradeCount] = useState("");
  const [isLoaded, setisLoaded] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    get_activationloadfunction();
    package_sales_summary();
    get_account_upgrade_count();
  }, []);

  useEffect(() => {
const isValid = v => v !== "" && v !== null && v !== undefined;
    setisLoaded(isValid(activationcardsList) && isValid(releaseList) && isValid(accountUpgradeCount));
  }, [activationcardsList, releaseList, accountUpgradeCount]);

  const get_activationloadfunction = () => {
    const apiUrl =
      process.env.REACT_APP_API_URL + "activationload_promo_wholesale_count";
    const form_data = {
      branchidno: get_cookies("branchidno"),
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      setActivationCardsList(res.data.unusedactivationcards);
    });
  };
  const get_account_upgrade_count = () => {
    const apiUrl =
      process.env.REACT_APP_API_URL + "account_upgrade_count_for_release";
    const form_data = {
      jc_user_id_no: get_cookies("branchidno"),
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      setAccountUpgradeCount(res.data.data);
      //       setisLoaded(true);
    });
  };

  const package_sales_summary = () => {
    //get data for warehouse/location dropdown
    const form_data = {
      hqidno: get_cookies("branchidno"),
      country: get_cookies("country"),
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl =
      process.env.REACT_APP_API_URL + "wholesale_summary_not_release_count";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      setReleaseList(res.data.rawpackagesalessummary);
      //       console.log("3434", res.data);
    });
  };
  const headers = {
    "Content-Type": "multipart/form-data",
    "Access-Control-Allow-Origin": process.env.REACT_APP_API_URL,
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <DashboardTwoTone />
        </div>
        <h4 className="header-title">Dashboard</h4>
        {console.log('test',get_cookies('branchname'))}
      </div>
      <div className="page-container-dashboard">
        {!isLoaded ? (
          <Preloader />
        ) : (
          <div className={classes.whiteContainer}>
            <div className={classes.cardHeader}>
              <div className={classes.cardHeaderBody}>
                     <h4 className="header-title">Welcome {get_cookies('fullname')}</h4>
                          <h4 className="header-title">{get_cookies('branchname')}</h4>
              </div>
            </div>
            {/* <div className={classes.cardDiv}>
              <div className={classes.card}>
                <h4 style={{ margin: "0 0 10px", color: "#555" }}>
                  Wholesale Set Pending Release
                </h4>
                <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
                  {releaseList}
                </p>
              </div>
              <div className={classes.card}>
                <h4 style={{ margin: "0 0 10px", color: "#555" }}>
                  Account Upgrade Pending Release
                </h4>
                <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
                  {accountUpgradeCount}
                </p>
              </div>
		<div className={classes.card}>
                <h4 style={{ margin: "0 0 10px", color: "#555" }}>
                  Available Activation Codes
                </h4>
                <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
                  {activationcardsList}
                </p>
              </div>
            </div> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
